module.exports = __webpack_public_path__ + "img/logo2.56d78568.png";